import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import ProjectModel from '@/views/Project/Project/models/project'

@Component({
    inheritAttrs: false,
    name: 'module-bklr',
    components: { DialogTemplate },
})
export default class ModuleBklr extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    get project(): ProjectModel {
        return this.props.project
    }
}
